import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Transaction from '~/types/Transaction';

export type TransactionsState = {
  readonly data: { [transactionId: string]: Readonly<Transaction> };
  readonly allIds: Readonly<Set<string>>;
  readonly isRefundLoading: boolean;
  readonly fetchingTransactions: boolean;
  readonly successfulTransactionsCount: number;
};

export const initialState: TransactionsState = {
  data: {},
  allIds: new Set(),
  isRefundLoading: false,
  fetchingTransactions: false,
  // This is used purely for tracking purposes
  successfulTransactionsCount: 0,
};

function reducer(state: TransactionsState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.FETCH_TRANSACTION:
      return {
        ...state,
        fetchingTransactions: true,
      };
    case ActionKeys.FETCH_TRANSACTION_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.transaction.objectId]: action.payload.transaction,
        },
        fetchingTransactions: false,
        allIds: state.allIds.add(action.payload.transaction.objectId),
      };
    }
    case ActionKeys.FETCH_TRANSACTION_ERROR:
      return {
        ...state,
        fetchingTransactions: false,
      };
    case ActionKeys.REFUND_TRANSACTION:
      return {
        ...state,
        isRefundLoading: true,
      };
    case ActionKeys.REFUND_TRANSACTION_SUCCESS:
    case ActionKeys.REFUND_TRANSACTION_ERROR:
      return {
        ...state,
        isRefundLoading: false,
      };
    case ActionKeys.UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT:
      return {
        ...state,
        successfulTransactionsCount: action.payload.count,
      };
    default:
      return state;
  }
}

export default reducer;
